export default 'sms';
